import { LightShowOperation } from './lightshow-operation';
import { LightshowState } from '../lightshow-state';
import { FlashTypes } from '../operation-types';

export class StrobeOperation extends LightShowOperation {
  private static readonly strobeDuration = 50;
  private ignoreOverlap: boolean;

  constructor(position: number, duration: number, sectionList: string[], ignoreOverlap = false, uniqueId = Math.random().toString(36).slice(-5)) {
    super();
    this.position = position;
    this.duration = duration;
    this.color = 'green';
    this.flashType = FlashTypes.strobeOn;
    this.timelineColor = 'red';
    this.uniqueId = uniqueId;
    this.ignoreOverlap = ignoreOverlap;
    this.sectionList = sectionList;
    this.operationFlashOn = false;
    this.show = true;
  }

  public toJson() {
    return [
      {
        type: FlashTypes.strobeOn,
        duration: Math.round(this.duration) / 1000,
        time: Math.round(this.position),
        sectionList: this.sectionList && this.sectionList.length > 0 ? this.sectionList : null
      }
    ];
  }

  public end(state: LightshowState) {
    state.isFlashOn = false;
    this.operationFlashOn = false;
  }
  public tick(state: LightshowState) {
    if (this.position) {
      state.isFlashOn = this.operationFlashOn = Math.floor((state.playbackPosition - this.position) / StrobeOperation.strobeDuration) % 2 === 0;
    }
    state.brightness = 1;
  }
  public wait () {}
}
